import React from "react";
import { Link } from "react-router-dom";
import {
  Building2,
  Landmark,
  Scroll,
  HeartHandshake,
  FileSignature,
  Stamp,
  ArrowRight,
} from "lucide-react";

const ICON_MAP = {
  "pendirian-pt-cv": Building2,
  "akta-jual-beli": Landmark,
  "waris-hibah": Scroll,
  "perjanjian-pranikah": HeartHandshake,
  "akta-wasiat": FileSignature,
  "legalisasi-waarmerking": Stamp,
};

export const Services = ({ services }) => {
  return (
    <section
      id="layanan"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="hp-divider" />
              <span className="overline">Layanan Kenotariatan</span>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#1A2B29] font-light tracking-tight leading-[1.05]">
              Enam bidang yang kami tangani secara <em className="italic text-[#C4A661]">tuntas</em>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base text-[#5C6B69] leading-relaxed">
              Pilih kategori yang paling dekat dengan kebutuhan Anda. Kami akan memandu Anda
              melalui dokumen, prosedur, dan implikasi hukumnya melalui kontak resmi kantor.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E3DC] border border-[#E5E3DC]">
          {services.map((s, i) => {
            const Icon = ICON_MAP[s.slug] || Scroll;
            return (
              <article
                key={s.slug}
                data-testid={`service-card-${s.slug}`}
                className="bg-[#F9F8F6] p-8 lg:p-10 group transition-all duration-300 hover:bg-white relative"
              >
                <div className="flex items-start justify-between mb-7">
                  <div className="w-14 h-14 border border-[#1A2B29]/15 flex items-center justify-center group-hover:bg-[#1A2B29] transition-colors duration-300">
                    <Icon
                      size={26}
                      strokeWidth={1.2}
                      className="text-[#1A2B29] group-hover:text-[#C4A661] transition-colors"
                    />
                  </div>
                  <span className="font-serif italic text-[#C4A661] text-sm">
                    0{i + 1}
                  </span>
                </div>

                <h3 className="font-serif text-2xl lg:text-[26px] text-[#1A2B29] leading-tight mb-3 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-sm text-[#5C6B69] leading-relaxed mb-6">{s.short}</p>

                <ul className="space-y-2 mb-8">
                  {s.items.map((it) => (
                    <li
                      key={it}
                      className="text-xs text-[#1A2B29] flex items-center gap-2"
                    >
                      <span className="w-1 h-1 bg-[#C4A661] rounded-full" />
                      {it}
                    </li>
                  ))}
                </ul>

                <Link
                  to={`/layanan/${s.slug}`}
                  data-testid={`service-cta-${s.slug}`}
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-semibold text-[#1A2B29] hover:text-[#C4A661] transition-colors"
                >
                  Detail layanan <ArrowRight size={14} />
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
